/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		// Optional
		loadProductFirst: false,
		defaultDisplay: boostPFSThemeConfig.custom.layout,
		showPlaceholderProductList: false,
		filterTreeMobileStyle: 'style3',
	},
};

(function() {
	BoostPFS.inject(this);
	
	ProductGridItem.prototype.compileTemplate = function(data) {
		if(!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}

		const getMetafieldValueByKey = (key) => {
			let metafields = data.metafields.filter(metafield => metafield.key === key)
			if (metafields.length > 0) {
				return metafields[0].value
			}

			return null
		}

    const itemTag = data.tags;

    /* [(+)] +++++++++ GET THE PRE-ORDER Metafield +++++++++ [(+)] */
    const isPreOrder = getMetafieldValueByKey("pre_order") ? JSON.parse(getMetafieldValueByKey("pre_order")) : undefined

    /* [(+)] +++++++++ GET THE BEST SELLER TAG +++++++++ [(+)] */
    const searchBestSeller = "Best Seller";
    const formatBestSeller = itemTag.filter((elementTag) => elementTag.indexOf(searchBestSeller) > -1);
    const bestSellerTag = formatBestSeller.toString();

    /* [(+)] +++++++++ GET THE STAFF PICK TAG +++++++++ [(+)] */
    const searchStaffPick = "Staff Pick";
    const formatStaffPick = itemTag.filter((elementTag) => elementTag.indexOf(searchStaffPick) > -1);
    const staffPickTag = formatStaffPick.toString();

    /* [(+)] +++++++++ GET THE WATER RESISTANT TAG +++++++++ [(+)] */
    const searchContent = "Water Resistant";
    const formatContent = itemTag.filter((elementTag) => elementTag.indexOf(searchContent) > -1);
    const contentTag = formatContent.toString();
		/*** End Prepare data ***/
		
		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add a specific class for grid item
		var itemGridWidthClass = '';
		var imageSize = '600x600';

		switch (boostPFSConfig.custom.products_per_row) {
			case 2:
				itemGridWidthClass = 'medium-up--one-half';
				imageSize = '540x600';
				break;
			case 3:
				itemGridWidthClass = 'small--one-half medium-up--one-third';
				imageSize = '345x550';
				break;
			case 4:
				itemGridWidthClass = 'small--one-half medium-up--one-quarter';
				imageSize = '250x';
				break;
			case 5:
				itemGridWidthClass = 'small--one-half medium-up--one-fifth';
				imageSize = '195x';
				break;
		}
		itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

		// Add soldOut class
		var itemSoldOutClass = soldOut ? ' is-sold-out' : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

    /* [(+)] +++++++++ SOLD OUT TAG +++++++++ [(+)] */
		var soldOutTag = soldOut ? ' sold-out-tag' : '';
		itemHtml = itemHtml.replace(/{{soldOutTag}}/g, soldOutTag);

    /* [(+)] +++++++++ Add Sale tag +++++++++ [(+)] */
    if (isPreOrder) {
      var itemSaleClass = '';
      itemHtml = itemHtml.replace(/{{itemSaleClass}}/g, itemSaleClass);
    } else {
      var itemSaleClass = onSale ? ' sale-tag' : '';
      itemHtml = itemHtml.replace(/{{itemSaleClass}}/g, itemSaleClass);
    }

    /* [(+)] +++++++++ Add Best Seller tag +++++++++ [(+)] */
    if (!data.available || isPreOrder || onSale) {
      var bestSeller = '';
      itemHtml = itemHtml.replace(/{{bestSeller}}/g, bestSeller);
    } else {
      var bestSeller = bestSellerTag ? ' best-seller-tag' : '';
      itemHtml = itemHtml.replace(/{{bestSeller}}/g, bestSeller);
    }

    /* [(+)] +++++++++ Add Staff Pick tag +++++++++ [(+)] */
    if (!data.available || isPreOrder || onSale || bestSellerTag) {
      var staffPick = '';
      itemHtml = itemHtml.replace(/{{staffPick}}/g, staffPick);
    } else {
      var staffPick = staffPickTag ? ' staff-pick-tag' : '';
      itemHtml = itemHtml.replace(/{{staffPick}}/g, staffPick);
    }

    /* [(+)] +++++++++ Add Water Resistant tag +++++++++ [(+)] */
    var waterResistant = contentTag ? contentTag : '';
    itemHtml = itemHtml.replace(/{{waterResistant}}/g, waterResistant);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

		/* [(+)] +++++++++ Build Badge Pre-order +++++++++ [(+)] */
		let itemBadge = ""
		if (isPreOrder && data.available) {
			itemBadge = `
				<div class="product-badge product-card-icon-pre-order-collection product-badge-icon-pre-order">
					${window.theme.icon_pre_order}
				</div>
			`
		}
		itemHtml = itemHtml.replace(/{{itemBadge}}/g, itemBadge);
	
		/* [(+)] +++++++++ Build Image +++++++++ [(+)] */
		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;

		// Build Image style
		var imageStyle = buildImageStyle(data);
		itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

		// Add Images
    var noImageHtml = images !== undefined ? '' : ' no-image';
    itemHtml = itemHtml.replace(/{{noImage}}/g, noImageHtml);

    var itemImagesHtml = '<img id="' + imgId + '" ' +
    'class="product-card-image is-main-image lazyload"' +
    'data-src="' + Utils.getFeaturedImage(images, '300x300') + '" ' +
    'alt="{{itemTitle}}">';
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    if (data.images[2] !== undefined) {
      var itemSecondImageHtml = '<img ' +
      'class="product-card-image is-second-image lazyload"' +
      'data-src="' + data.images[2] + '" ' +
      'alt="{{itemTitle}}">';
      itemHtml = itemHtml.replace(/{{itemSecondImage}}/g, itemSecondImageHtml);
    } else {
      var itemSecondImageHtml = '';
      itemHtml = itemHtml.replace(/{{itemSecondImage}}/g, itemSecondImageHtml);
    }

		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

    // window.console.log(JSON.stringify(data.tags));

		return itemHtml;
	}

	ProductListItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/
	
		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;
	
		// Add onSale label
		var itemSaleLabel = onSale ? boostPFSTemplate.saleLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);
	
		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);
	
		// Add Thumbnail
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '600x600') : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
	
		// Add Vendor
		var itemSmallVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorSmallListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
		var itemMediumVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorMediumListHtml : '';
		itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);
	
		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}
	
		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
	
		return itemHtml;
	}

	// Build Image style
	function buildImageStyle(data) {
		var images = data.images_info;
		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;
		var imageStyle = '';
		if (images.length > 0) {
			var image = images[0];
			var width = boostPFSConfig.custom.max_height;
			var height = boostPFSConfig.custom.max_height;
			var aspect_ratio = image.width / image.height;
			var small_style = true;
			var container_aspect_ratio = width * 1.0 / height;

			if (image.aspect_ratio < 1.0) {
				var maximum_width = height * aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					maximum_width = image.width;
				} else {
					var maximum_height = height;
				}
			} else if (aspect_ratio < container_aspect_ratio) {
				var maximum_height = height / aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					var maximum_width = image.width;
				} else {
					var maximum_height = height;
					var maximum_width = height * aspect_ratio;
				}
			} else {
				var maximum_height = height / aspect_ratio;
				if (image.width <= width) {
					maximum_height = image.height;
					var maximum_width = image.width
				} else {
					var maximum_width = width;
					maximum_height = maximum_width / aspect_ratio;
				}
			}

			imageStyle += '<style>';
			if (small_style) imageStyle += '@media screen and (min-width: 750px) {';
			imageStyle += '#' + imgId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}' +
				'#' + wrapperId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}';
			if (small_style) imageStyle += '}';

			if (small_style) {
				if (aspect_ratio < 1) {
					maximum_width = 750 * aspect_ratio;
				} else {
					if (image.width < 750) {
						maximum_width = image.width;
					} else {
						maximum_width = 750;
					}
				}
				imageStyle += '@media screen and (max-width: 749px) {'
				imageStyle += '#' + imgId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'max-height: 750px;' +
					'}' +
					'#' + wrapperId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'}';
				imageStyle += '}';
			}
			imageStyle += '</style>';
		}
		return imageStyle;
	}

	function buildPrice(data, onSale, priceVaries) {
		var priceHtml = '',
			onSaleClass = onSale && data.available ? ' price--on-sale' : '';
	
		priceHtml += '<dl class="price' + onSaleClass + '" data-price>';
		// if (boostPFSConfig.custom.vendor_enable) {
		// 	priceHtml += '<div class="price__vendor">';
		// 	priceHtml += '<dt>';
		// 	priceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.vendor + '</span>';
		// 	priceHtml += '</dt>';
		// 	priceHtml += '<dd>';
		// 	priceHtml += data.vendor;
		// 	priceHtml += '</dd>';
		// 	priceHtml += '</div>';
		// }
		priceHtml += '<div class="price__regular">';
		priceHtml += '<dt>';
		priceHtml += '<span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.regular_price + '</span>';
		priceHtml += '</dt>';
		priceHtml += '<dd>';
		priceHtml += `<span class="price-item price-item--regular${data.available ? '' : ' price-sold-out'}" data-regular-price>`;
		if (data.available) {
			if (onSale) {
				priceHtml += Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat);
			} else {
				priceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
			}
		} else {
      priceHtml += '<span class="price-item">' + Utils.formatMoney(data.price_min, Globals.moneyFormat) + '</span>';
      priceHtml += " " + boostPFSConfig.label.sold_out;
    }
    // else {
		// 	priceHtml += boostPFSConfig.label.sold_out;
		// }
		priceHtml += '</span>';
		priceHtml += '</dd>';
		priceHtml += '</div>';
		priceHtml += '<div class="price__sale">';
		priceHtml += '<dt>';
		priceHtml += '<span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.sale_price + '</span>';
		priceHtml += '</dt>';
		priceHtml += '<dd>';
		priceHtml += '<span class="price-item price-item--sale" data-sale-price>';
		priceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
		priceHtml += '</span> ';
		// priceHtml += '<span class="price-item__label" aria-hidden="true">' + boostPFSConfig.label.sale + '</span>';
		priceHtml += '</dd>';
		priceHtml += '</div>';
		priceHtml += '</dl>';
	
		return priceHtml;
	}

	/// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
  
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }
  
    if (Settings.getSettingValue('general.paginationType') == 'default') {
      var paginationHtml = boostPFSTemplate.paginateHtml;
  
      // Build Previous
      var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
  
      // Build Next
      var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
  
      // Build page items
      // var currentPage = boostPFSConfig.label.current_page.replace(/{{ current }}/g, currentPage).replace(/{{ total }}/g, totalPage);
      // paginationHtml = paginationHtml.replace(/{{pageItems}}/g, currentPage);

      // [(+)] ++++++++ BUILD INDIVIDUAL PAGES ++++++++ [(+)]
      var pageIteration = '';

      for (pages = 1; pages <= totalPage; pages++) {
        pageIteration += `<a class="pagination-item${(currentPage === pages) ? ' js-is-active js-is-disabled' : ''}" href="${Utils.buildToolbarLink('page', currentPage, pages)}">${pages}</a>`;
      }

      paginationHtml = paginationHtml.replace(/{{individualPages}}/g, pageIteration);
  
      return paginationHtml;
    }
  };

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>View As </span>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
		var productSelector = jQ(Selector.products);
		if (Globals.queryParams.display == 'list') {
			if (productSelector.children('.list-view-items').length == 0) {
				productSelector.children().wrapAll('<ul class="list-view-items"></ul>');
			}
			productSelector.removeClass('grid grid--uniform grid--view-items');
		} else {
			if (productSelector.children('.list-view-items').length > 0) {
				productSelector.children('.list-view-items').children().unwrap();
			}
			productSelector.addClass('grid grid--uniform grid--view-items');
		}

    const productCardTitles = document.querySelectorAll('.product-card-title');

    const gridOptions = [
      {
        breakpoint: 1440,
        columns: 3,
      },
      {
        breakpoint: 980,
        columns: 2,
      },
    ];

    window.setHeightCardTexts(productCardTitles, '--product-card-title-height', gridOptions);
	}

	// Build Additional Elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		var totalProduct = '';
		if (data.total_product == 1) {
			totalProduct = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);

      $('.search-results-content').addClass('only-result');
		} else {
			totalProduct = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
	};
})();